import { pluralize } from 'humanize-plus'
import PropTypes from 'prop-types'
import React from 'react'

import { Button } from '@driftt/dds'
import {
  Div,
  Footer,
  H3,
  Modal,
  P,
  Section,
  Strong 
} from '@driftt/tide-core'

import './style.css'

const DeleteSegmentsConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  segmentsToDelete 
}) => {
  const numberOfSegments = segmentsToDelete.length
  const segmentsPluralized = pluralize(numberOfSegments, 'segment')

  const singleSelectionCopy = `If this segment is being used in a playbook, contacts in this segment will no longer see that playbook.`
  const multiSelectionCopy = `If these segments are being used in any playbooks, contacts in these segments will no longer see those playbooks.`

  const bodyCopy = numberOfSegments === 1 ? singleSelectionCopy : multiSelectionCopy

  return (
    <Modal 
      open={open}
      onClose={onClose}
      type="warning"
      size="small"
    >
      <H3>Delete {numberOfSegments} {segmentsPluralized}?</H3>
      <P>Are you sure you want to delete the following {segmentsPluralized}?</P>
      <Section className="contacts-segments--delete-modal--segments">
        {segmentsToDelete.map(segment => (
          <Div key={segment.id}><Strong>{segment.name}</Strong></Div>
        ))}
      </Section>
      <P>{bodyCopy}</P>
      <P>
        <Strong>This action cannot be undone.</Strong>
      </P>
      <Footer>
        <Button onClick={onConfirm}>Delete {segmentsPluralized}</Button>
        <Button variant="secondary" onClick={onClose}>Cancel</Button>
      </Footer>
    </Modal>
  )
}

DeleteSegmentsConfirmationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  segmentsToDelete: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired
  })).isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
}

export default DeleteSegmentsConfirmationModal
